import type { ProjectCliLogins } from "@/api/spaces";

/** The default login: never stored, and sent as-is to clear a saved login
 * (the backend merges patches, so dropping the key would keep it). */
export const DEFAULT_LOGIN = "default";

/** The Claude login these logins choose, the default when none is saved. */
export function claudeLoginOf(cliLogins: ProjectCliLogins | undefined): string {
  return cliLogins?.claude_cli ?? DEFAULT_LOGIN;
}
